import Api_Config from '../code/api/ApiConfig';
import AuthAdminUserModel from '../code/models/AuthAdminUserModel';
import Customer from '../code/models/Customer';

interface IBidNavForm {
    customer: Customer;
    adminUser: AuthAdminUserModel;
}

export default function BidNavForm({ customer, adminUser }: IBidNavForm) {
    function getProps() {
        let url = Api_Config.getBidNavUrlForCustomer(customer.customerId, adminUser.id);
        return {
            src: url,
            height: "100%",
            width: "100%"
        };
    }

    return (
        <iframe title='BidNav' {...getProps()}></iframe>
    )
}
